import { useEffect, useRef, useState } from "react";

type DebounceOptions<T> = {
  delay?: number;
  skipFirstRender?: boolean;
  callBack?: (debouncedValue: T) => void;
};
export function useDebounce<T>(value: T, { delay = 500, skipFirstRender, callBack }: DebounceOptions<T> = {}) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current && skipFirstRender) {
      isFirstRender.current = false;
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
      callBack?.(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}




export function useDebounceFn<T>(
  fn: (value: T) => void,
  delay = 500
) {
  const timer = useRef<NodeJS.Timeout | null>(null);

  const trigger = (value: T) => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      fn(value);
    }, delay);
  };

  return trigger;
}